import { Component, OnInit, ViewChild, ElementRef, Input, Output, Inject, EventEmitter, OnChanges} from '@angular/core';
import { HttpEventType, HttpClient, HttpHeaders } from '@angular/common/http';
import {
  environment
} from 'src/environments/environment';
@Component({
  selector: 'app-upload-dragdrop',
  templateUrl: './upload-dragdrop.component.html',
  styleUrls: ['./upload-dragdrop.component.css']
})
export class UploadDragdropComponent implements OnChanges {
  
  @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;
  files: any[] = [];
  @Output() public onUploadFinished = new EventEmitter();

  @Input() PathFile: string;
  @Input() Multiple: string;
  @Input() IsClearList: string;
  public uploadcount: number;
  public baseurl: string;
  public returnObj: object = {};

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseurl = environment.base_api;
  }
  ngOnChanges(): void {
    
    if (!!this.IsClearList && this.IsClearList == "true") {
      this.files = [];
    }
  }
  

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    
    if (this.Multiple == "true") {
      this.prepareFilesList($event);
    } else {
      if ($event.length > 1) {
        this.returnObj = {
          Message: "Please upload only 1 file.",
          Files: [],
          PathFile: ''
        };
        this.onUploadFinished.emit(this.returnObj);
        return;
      } else {
        this.prepareFilesList($event);
      }
    }
    
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    if (this.Multiple == 'true') {
      this.prepareFilesList(files);
    } else {
      if (files.length > 1) {
        this.returnObj = {
          Message: "Please upload only 1 file.",
          Files: [],
          PathFile: ''
        };
        this.onUploadFinished.emit(this.returnObj);
        return;
      } else {
        this.prepareFilesList(files);
      }
    }
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    if (this.files[index].progress < 100) {
      console.log("Upload in progress.");
      return;
    }
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        
        this.returnObj = {
          Message: "",
          Files: this.files,
          PathFile: this.PathFile

        }
        this.onUploadFinished.emit(this.returnObj);

        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
           
            //Initial data from lib
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {

            //Send to save each file
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.fileDropEl.nativeElement.value = "";
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }


}
